export default {
  DPS_TRADER: 'DPS_TRADER',
};
